<app-header-one [sticky]="false" [topbar]="false"></app-header-one>
<router-outlet></router-outlet>
<app-footer-one [class]="'footer-light pet-layout-footer'"></app-footer-one>
